import _ from "lodash";

const useFormHandlers = setter => {
  const handleInputChange = (name, value) =>
    setter((item) => {
      const clone = _.cloneDeep(item)
      _.set(clone, name, value)
      return clone
    })

  const handleInputEvent = e => {
    const {name, value, checked, type} = e.target
    handleInputChange(name, type === "checkbox" ? checked : value)
  }

  return {
    handleInputChange,
    handleInputEvent
  }
}

export default useFormHandlers;